import React, { Component, forwardRef } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../utils/withRouter";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Tab, Nav } from "react-bootstrap";
import Loader from "../../utils/Loader";
import { Link, Element } from "react-scroll";

class viewSpecification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    };
  }
  async componentDidMount() {}
  render() {
    const { isLoading } = this.state;
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <header
            id="header"
            className="fixed-top"
            style={{ background: "#d3f6de" }}
          >
            <div className="container-fluid d-flex align-items-center">
              {/* <h1 class="logo mr-auto"><a href="index.html"><span>Com</span>pany</a></h1> */}
              <a href="index.html" className="logo mr-auto">
                <img
                  src="img/itmeLogoTm-removebg.png"
                  alt=""
                  className="img-fluid"
                />
              </a>
              <img
                src="img/down__2__page-0001-removebg-preview.png"
                aria-colcount=""
                alt=""
                className="img-fluid login-sec-logo"
              />
              <div>
                <img
                  src="img/right-logo-top.png"
                  aria-colcount=""
                  style={{ top: "-20px", right: "-20px" }}
                  alt=""
                  className="img-fluid login-sec-logo"
                />
                <a href="index.html" className="logo mr-auto">
                  <img src="img/right_logo.png" alt="" className="img-fluid" />
                </a>
              </div>
            </div>
          </header>
          <div
            className="dust_pattern pt-5 lazy-container"
            style={{ marginTop: 86 }}
          >
            <div className="container pt-3 ">
              <h2 className="text-center font-weight-bold mb-5">
                Venues Available
              </h2>
              <ul
                className="nav nav-pills mb-5 justify-content-center"
                id="pills-tab"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <a
                    href="#Layout"
                    style={{ color: "black", textDecoration: "none" }}
                    role="tab"
                    aria-controls="pills-home"
                    aria-selected="true"
                  >
                    <Link
                      to="Sanskriti"
                      class="nav-link"
                      style={{ cursor: "pointer" }}
                      smooth={true}
                      duration={500}
                      offset={-100}
                    >
                      Sanskriti Kendra I
                    </Link>
                  </a>
                  <span className="round_1" />
                  <span className="round_2" />
                  <span className="round_3" />
                  <span className="round_4" />
                </li>
                <li className="nav-item" role="presentation">
                  <a
                    href="#Layout"
                    style={{ color: "black", textDecoration: "none" }}
                    role="tab"
                    aria-controls="pills-profile"
                    aria-selected="false"
                  >
                    <Link
                      to="Sanskriti"
                      class="nav-link"
                      style={{ cursor: "pointer" }}
                      smooth={true}
                      duration={500}
                      offset={-100}
                    >
                      Sanskriti Kendra II
                    </Link>
                  </a>
                  <span className="round_1" />
                  <span className="round_2" />
                  <span className="round_3" />
                  <span className="round_4" />
                </li>
                <li className="nav-item" role="presentation">
                  <a
                    className="nav-link active"
                    style={{ width: "100%" }}
                    id="pills-contact-tab"
                    data-toggle="pill"
                    href="#pills-contact"
                    role="tab"
                    aria-controls="pills-contact"
                    aria-selected="false"
                  >
                    <Link
                      to="Swastika"
                      class="nav-link"
                      style={{ cursor: "pointer" }}
                      smooth={true}
                      duration={500}
                      offset={-100}
                    >
                      Swastika
                    </Link>
                  </a>
                  <span className="round_1" />
                  <span className="round_2" />
                  <span className="round_3" />
                  <span className="round_4" />
                </li>
              </ul>
              <div
                className="tab-pane fade show active text-center p-3"
                id="pills-contact"
                role="tabpanel"
                aria-labelledby="pills-contact-tab"
              >
                <Element name="Swastika" className="element">
                  <h3 style={{ fontWeight: "bold" }} className="pb-3">
                    Swastika
                  </h3>
                </Element>
                <p>
                  <b>Features</b> – B2B Meetings, Arbitrations, Small Press
                  Conferences, Long Term Work Stations, Board Meetings
                </p>
                <p>
                  <b>Facilities </b> – Reception Area, Board Room, Manager Room,
                  Pantry, Washrooms, Prefunction Area.
                </p>
                <br />
                <h3 className="mb-4">
                  <b>Layout Options</b>
                </h3>
                <div className="container p-2">
                  <div className="row layout-options">
                    <div className="col-md-4">
                      <a
                        href="img/floor_plan/20230810_Board_Seating_Arrangement_Floor_Plan,_ITME_Center,_109_page-0001.jpg"
                        target="_blank"
                      >
                        <img
                          src="img/floor_plan/20230810_Board_Seating_Arrangement_Floor_Plan,_ITME_Center,_109_page-0001.jpg"
                          className="img-fluid"
                        />
                      </a>
                    </div>
                    <div className="col-md-4">
                      <a
                        href="img/floor_plan/Floor_Plan_Mittal_Tower_2.jpg"
                        target="_blank"
                      >
                        <img
                          src="img/floor_plan/Floor_Plan_Mittal_Tower_2.jpg"
                          className="img-fluid"
                        />
                      </a>
                    </div>
                    <div className="col-md-4">
                      <a
                        href="img/floor_plan/Floor_Plan_Mittal_Tower_3.jpg"
                        target="_blank"
                      >
                        <img
                          src="img/floor_plan/Floor_Plan_Mittal_Tower_3.jpg"
                          className="img-fluid"
                        />
                      </a>
                    </div>
                    <div className="col-md-4 mt-4">
                      <a href="img/floor_plan/plan-4.jpg" target="_blank">
                        <img
                          src="img/floor_plan/plan-4.jpg"
                          className="img-fluid"
                        />
                      </a>
                    </div>
                    <div className="col-md-4 mt-4">
                      <a href="img/floor_plan/plan-5.jpg" target="_blank">
                        <img
                          src="img/floor_plan/plan-5.jpg"
                          className="img-fluid"
                        />
                      </a>
                    </div>
                    <div className="col-md-4 mt-4">
                      <a href="img/floor_plan/plan-6.jpg" target="_blank">
                        <img
                          src="img/floor_plan/plan-6.jpg"
                          className="img-fluid"
                        />
                      </a>
                    </div>
                  </div>
                  <br />
                  <div className="btn-group">
                    <p className="text-center mt-4 mr-2">
                      <a
                        target="_blank"
                        href="https://itmecenter.in/Pdf/SWASTIKA.pdf"
                        style={{ textDecoration: "none", borderRadius: 10 }}
                        className=" text-center mt-4 btn-red"
                      >
                        {" "}
                        Technical Specifications
                      </a>
                    </p>
                    <p className="text-center mt-4">
                      <a
                        target="_blank" onClick={()=>this.props.navigate('/calenderView',{state:{
                          Code:"C001"
                        }})}
                        style={{ textDecoration: "none", borderRadius: 10,cursor:'pointer' }}
                        className=" text-center mt-4 btn-red btn-green"
                      >
                        {" "}
                        Book Now
                      </a>
                    </p>
                  </div>
                </div>
              </div>
              <br />
              <br />
              <div className="row layout-options">
                <div className="col-md-3">
                  <img
                    src="img/floor_plan/477396258_IMG_2333.JPG"
                    className="img-fluid"
                  />
                </div>
                <div className="col-md-3">
                  <img
                    src="img/floor_plan/894603902_IMG_2279.JPG"
                    className="img-fluid"
                  />
                </div>
                <div className="col-md-3">
                  <img
                    src="img/floor_plan/1979268776_IMG_2281.JPG"
                    className="img-fluid"
                  />
                </div>
                <div className="col-md-3">
                  <img
                    src="img/floor_plan/1375698906_IMG_2283.JPG"
                    className="img-fluid"
                  />
                </div>
                <div className="col-md-3 mt-3">
                  <img
                    src="img/floor_plan/1148957163_IMG_2291.JPG"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="dust_pattern py-5">
            <div className="container" id="Layout">
              <Element name="Sanskriti" className="element">
                <h2 className="text-center mt-5 mb-5 font-weight-bold">
                  Sanskriti Kendra I &amp; II
                </h2>
              </Element>
              <h3 className="text-center mt-5 mb-5 font-weight-bold">
                Layout Options
              </h3>
              <div className="row layout-options">
                <div className="col-md-4">
                  <a
                    href="img/floor_plan/20230810_Board_Seating_Arrangement_Floor_Plan,_ITME_Center,_109_page-0001.jpg"
                    target="_blank"
                  >
                    <img
                      src="img/floor_plan/20230810_Board_Seating_Arrangement_Floor_Plan,_ITME_Center,_109_page-0001.jpg"
                      className="img-fluid"
                    />
                  </a>
                </div>
                <div className="col-md-4">
                  <a
                    href="img/floor_plan/20230810_Cluster_Seating_Arrangement_Floor_Plan,_ITME_Center,_109_page-0001.jpg"
                    target="_blank"
                  >
                    <img
                      src="img/floor_plan/20230810_Cluster_Seating_Arrangement_Floor_Plan,_ITME_Center,_109_page-0001.jpg"
                      className="img-fluid"
                    />
                  </a>
                </div>
                <div className="col-md-4">
                  <a
                    href="img/floor_plan/20230810_Theatre_Arrangement_Floor_Plan,_ITME_Center,_109_112,_Dalamal_page-0001.jpg"
                    target="_blank"
                  >
                    <img
                      src="img/floor_plan/20230810_Theatre_Arrangement_Floor_Plan,_ITME_Center,_109_112,_Dalamal_page-0001.jpg"
                      className="img-fluid"
                    />
                  </a>
                </div>
              </div>
              <div className="btn-group justify-content-center d-flex mt-4">
                <p className="text-center mt-4 mr-2">
                  <a
                    target="_blank"
                    href="https://itmecenter.in/Pdf/SANSKRITI-HALL-1-and-2.pdf"
                    style={{ textDecoration: "none", borderRadius: 10 }}
                    className=" text-center mt-4 btn-red"
                  >
                    {" "}
                    View Technical Specifications
                  </a>
                </p>
                <p className="text-center mt-4">
                  <a
                    target="_blank"
                    onClick={()=>this.props.navigate('/calenderView',{state:{
                      Code:"C002"
                    }})}
                    style={{ textDecoration: "none", borderRadius: 10,cursor:'pointer' }}
                    className=" text-center mt-4 btn-red btn-green"
                  >
                    {" "}
                    Book Now
                  </a>
                </p>
              </div>
            </div>
          </div>
          <footer style={{ backgroundColor: "#d3f6de" }}>
            <div
              className="container-fluid py-2  px-5 footer-text"
              style={{ position: "relative", zIndex: 5 }}
            >
              <div className="row mt-3">
                <div className="col-lg-9">
                  <div className="d-md-flex align-items-center">
                    <a href="AboutITME.aspx">
                      <img
                        src="https://itmecenter.in/images/footer-green.png"
                        style={{ maxWidth: 160 }}
                      />
                    </a>
                    <h3
                      style={{ fontSize: 25, fontWeight: "bold" }}
                      className="pl-md-4 py-3 py-md-0  footer-india"
                    >
                      India International Textile Machinery Exhibitions Society
                    </h3>
                  </div>
                </div>
                <div className="col-lg-3 d-flex justify-content-end ">
                  <div className="social-svg">
                    <div className="svg-social">
                      <a
                        target="_blank"
                        href="https://www.facebook.com/itmecenterindia?mibextid=ZbWKwL"
                      >
                        <i
                          className="fa fa-facebook social-svg-icon social-svg-facebook"
                          style={{ color: "#007bff" }}
                        />
                      </a>
                    </div>
                    <div className="svg-social">
                      {" "}
                      <a
                        target="_blank"
                        href="https://www.instagram.com/itmecenterindia/?igsh=MTRtcXB3ZmtieWN0"
                      >
                        <i
                          className="fa fa-instagram social-svg-icon"
                          style={{ color: "#007bff" }}
                        />
                      </a>
                    </div>
                    <div className="svg-social">
                      {" "}
                      <a
                        target="_blank"
                        href="https://www.linkedin.com/company/itme-center/"
                      >
                        <i
                          className="fa fa-linkedin social-svg-icon"
                          style={{ color: "#007bff" }}
                        />
                      </a>
                    </div>
                    <div className="svg-social">
                      <a
                        target="_blank"
                        href="https://www.youtube.com/@ITMECenterIndia?si=YIsOQETPTIKRFq8O"
                      >
                        <i
                          className="fa fa-youtube-play social-svg-icon"
                          style={{ color: "#007bff" }}
                        ></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-2 ">
                <div className="col-lg-5 col-md-6  contact_div">
                  <div
                    className="svg-1"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "1.5rem",
                    }}
                  >
                    <div className="svg">
                      <i className="fas fa-map-marker-alt" />
                    </div>
                    <h6 className="mb-3 one-line-footer">
                      <span style={{ textIndent: "-12px" }}>
                        {" "}
                        <i className="fa fa-map-marker" /> &nbsp;1210/1211/1212
                        Dalamal Tower, ‘A’ Wing, 12th Floor, Plot No.211,
                        Nariman Point, Mumbai – 400 021, INDIA
                      </span>
                    </h6>
                  </div>
                  <div className="svg-1">
                    <h6 className="mb-3">
                      <span>
                        <a
                          style={{ color: "black", textDecoration: "none" }}
                          href="tel:+912249724603"
                        >
                          <i className="fa fa-phone" /> +91-22-49724603
                        </a>
                      </span>
                    </h6>
                  </div>
                  <div className="svg-1">
                    <h6 className="mb-3">
                      <span>
                        <a
                          style={{ color: "black", textDecoration: "none" }}
                          href="tel:+918591951769"
                        >
                          <i className="fa fa-mobile" /> +91-85919 51769
                        </a>
                      </span>
                    </h6>
                  </div>
                  <div className="svg-1">
                    <h6 className="mb-3">
                      <a
                        style={{ color: "black", textDecoration: "none" }}
                        target="_blank"
                        href="//api.whatsapp.com/send?phone=977021089987"
                      >
                        <i className="fa fa-whatsapp" /> +97-70210 89987
                      </a>
                    </h6>
                  </div>
                  <div className="svg-1">
                    <h6 className="mb-3">
                      <p className="mb-0">
                        <a
                          style={{ color: "black", textDecoration: "none" }}
                          href="mailto:contact@itmecenter.in"
                        >
                          <i className="fa fa-envelope-o" />{" "}
                          contact@itmecenter.in
                        </a>{" "}
                        /{" "}
                        <a
                          style={{ color: "black", textDecoration: "none" }}
                          href="mailto:itme@india-itme.com"
                        >
                          itme@india-itme.com
                        </a>
                      </p>
                    </h6>
                  </div>
                </div>
                <div
                  className="col-lg-3 col-md-12  mt-4 mt-lg-0 contact_div"
                  style={{ borderRight: "2px solid black" }}
                >
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3774.1575751101454!2d72.82182580992911!3d18.92441815664134!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7d1eec807af1b%3A0x2addede9776ec83!2sIndia%20ITME%20Society!5e0!3m2!1sen!2sin!4v1684486283840!5m2!1sen!2sin"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  />
                </div>
                <div className="col-lg-4 col-md-6 pl-lg-5 mt-4 mt-lg-0  quicklink footer-about-venue">
                  <ul className="row footer-3row ">
                    <li className="col-md-6 mb-3">
                      <a className="nav-link" href="AboutITME.aspx">
                        About us <span className="sr-only">(current)</span>
                      </a>
                    </li>
                    <li className="col-md-6 mb-3 pl-3 text-lg-right">
                      <a className="nav-link" href="Venue.aspx">
                        Venue <span className="sr-only">(current)</span>
                      </a>
                    </li>
                    <li className="col-md-6 mb-3">
                      <a className="nav-link" href="Suitability.aspx">
                        Suitability<span className="sr-only">(current)</span>
                      </a>
                    </li>
                    <li className="col-md-6 mb-3 pl-3 text-lg-right">
                      <a className="nav-link" href="Contact_us.aspx">
                        Contact us <span className="sr-only">(current)</span>
                      </a>
                    </li>
                    <li className="col-md-6 mb-3 ">
                      <a className="nav-link" href="Events_Gallery.aspx">
                        Events Gallery{" "}
                        <span className="sr-only">(current)</span>
                      </a>
                    </li>
                    <li className="col-md-6 text-lg-right mb-3 ">
                      <a className="nav-link" href="Privacy-Policy.aspx">
                        Privacy Policy{" "}
                        <span className="sr-only">(current)</span>
                      </a>
                    </li>
                  </ul>
                  <div className="d-none">
                    <div className="d-flex align-items-center email-box">
                      <input
                        name="ctl00$txt"
                        type="text"
                        id="ctl00_txt"
                        className="form-control "
                        placeholder="Your Email"
                        style={{ borderRadius: 0, height: 41 }}
                      />
                      <input
                        type="submit"
                        name="ctl00$Button1"
                        defaultValue="Submit"
                        id="ctl00_Button1"
                        className="btn-yellow btn-yellow-master"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </footer>
          <section style={{ backgroundColor: "#505050" }}>
            <div className="container py-3">
              <p
                style={{ marginBottom: 0, color: "white", fontSize: 16 }}
                className="pb-0 text-center"
              >
                Ownership: All content and images used on this site are owned or
                licensed by India ITME Society. You may not copy, reproduce,
                distribute, publish, display, perform, modify, create derivative
                works, transmit, or in any other way exploit any part of
                copyrighted material without permission of the copyright owner.
                Failure to comply shall result in legal action.
              </p>
            </div>
          </section>
        </>
      </>
    );
  }
}
export default withRouter(connect(null, {})(viewSpecification));
